// 资源加载页面 - 提取自 LoginWelcomePage
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getImageUrl, getAllImages } from '../utils/assets';
import { preloadImages } from '../utils/imagePreloader';
import './LoginWelcomePage.css'; // 复用样式

interface LoadingScreenProps {
  onComplete: () => void;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ onComplete }) => {
  const { t } = useTranslation();
  const [loadingProgress, setLoadingProgress] = useState(0);
  const [loadingMessage, setLoadingMessage] = useState('');
  const [hasError, setHasError] = useState(false);

  // Rem adaptation logic (reused)
  useEffect(() => {
    const setRem = () => {
      const html = document.documentElement as HTMLElement;
      let width = html.clientWidth;
      if (width > 750) width = 750;
      html.style.fontSize = width / 7.5 + 'px';
    };
    setRem();
    const onResize = () => setRem();
    const onPageshow = (e: any) => { if (e && e.persisted) setRem(); };
    window.addEventListener('resize', onResize);
    window.addEventListener('pageshow', onPageshow as any);
    return () => {
      window.removeEventListener('resize', onResize);
      window.removeEventListener('pageshow', onPageshow as any);
    };
  }, []);

  // 开始加载游戏资源
  useEffect(() => {
    startLoading();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const startLoading = () => {
    setHasError(false);
    setLoadingProgress(0);
    setLoadingMessage(t('welcome.loadingConfig'));
    
    // 模拟配置文件加载
    const timer = setTimeout(() => {
      setLoadingMessage(t('welcome.loadingAssets'));
      
      const images = getAllImages();
      preloadImages(images, 
        (progress) => {
          setLoadingProgress(progress.percentage);
          setLoadingMessage(t('welcome.loadingAssets') + ` (${progress.loaded}/${progress.total})`);
        },
        () => {
          setLoadingProgress(100);
          // Small delay to show 100%
          setTimeout(() => {
            onComplete();
          }, 500);
        },
        (failed) => {
          console.error('Failed to load images:', failed);
          setHasError(true);
          setLoadingMessage(t('errors.loadingError', '加载失败，请重试'));
        }
      );
    }, 1000);

    return () => clearTimeout(timer);
  };

  return (
    <div className="login-scroll-container">
      <div className="login-canvas">
        <div className="login-frame">
          <div className="bg-empty" />
          {/*<div className="bg-main" style={{ backgroundImage: `url(${getImageUrl('welcome/bg-layer-1.png')})` }} />*/}
          <div className="bg-overlay" style={{ backgroundImage: `url(${getImageUrl('welcome/bg-layer-2.png')})` }} />
          <div className="character" style={{ backgroundImage: `url(${getImageUrl('welcome/title-decoration.png')})` }} />

          {/* 进度条区域 */}
          <div className="welcome-loading-text">{t('welcome.loadingMessage')}</div>
          <div className="progress-bar-bg" style={{ backgroundImage: `url(${getImageUrl('welcome/progress-bar-bg.png')})` }} />
          <div
            className="progress-bar-fill"
            style={{
              width: `calc(5.78rem * ${loadingProgress} / 100)`,
              backgroundImage: `url(${getImageUrl('welcome/progress-bar-fill.png')})`
            }}
          />
          <div className="progress-text">
            {loadingMessage} {loadingProgress}%
          </div>
          
          {hasError && (
            <div 
              className="retry-button"
              onClick={startLoading}
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                zIndex: 100,
                padding: '10px 20px',
                background: 'rgba(0,0,0,0.8)',
                border: '1px solid #fff',
                borderRadius: '8px',
                color: '#fff',
                cursor: 'pointer',
                marginTop: '60px' // Move it below the progress bar
              }}
            >
              {t('common.retry', '重試')}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
